import { http, HttpResponse } from "msw";
import { apiPaths } from "../../api-paths.js";

export const phonesHandlers = {
  sendCode: [
    http.post(`**${apiPaths.phones.sendVerificationCode}`, () => {
      return HttpResponse.json({}, { status: 200 });
    }),
  ],
};
